export default __webpack_public_path__ + "static/img/vogue_test_scene_1_0145.52a19a9.webp";